// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u_rL","largestCol":"styles_largestCol__35jOU","smallestCol":"styles_smallestCol__1PMsb"};